import script from "./MiscellaneousPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MiscellaneousPage.vue?vue&type=script&setup=true&lang=js"

import "./MiscellaneousPage.vue?vue&type=style&index=0&id=10e4f316&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e4f316"]])

export default __exports__